import type { HTMLAttributes } from 'react'
import { clsx } from 'clsx'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx('rounded-2xl border border-line bg-panel p-4.5 shadow-[0_10px_30px_#0002]', className)}
      {...props}
    />
  )
}
